var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSignOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 5.56155C14 4.64382 13.3754 3.84385 12.4851 3.62127L4.48507 1.62127C3.22278 1.30569 2 2.26041 2 3.56155V20.4384C2 21.7396 3.22278 22.6943 4.48507 22.3787L12.4851 20.3787C13.3754 20.1561 14 19.3562 14 18.4384V5.56155Z",
    fill: "#FBEEEE",
    stroke: "#D22827",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5001 8.49994L22.0001 12L18.5001 15.5001",
    stroke: "#D22827",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 12H8",
    stroke: "#D22827",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignOut);
export default __webpack_public_path__ + "static/media/sign-out.a6e25065.svg";
export { ForwardRef as ReactComponent };